import React, { Component } from "react";
import remotePointList from "../Loop/RemotePointList";
import DataMapping from "../Loop/DataMapping";
import Popup from "reactjs-popup";
import SwitchOnOff from "./SwitchOnOff";
import SwitchOnOff_boolean from "./SwitchOnOff_boolean";
// import ArrowMoving from "../Loop/Animation/ArrowMoving";
// import PlayAndPause from "../Loop/Animation/PlayAndPause";
// import FanImage from "../../images/Propeller.gif";
// import FireImage from "../../images/fire.gif";
// import NoFire from "../../images/NoFire.gif";
import Arrow from "../Animation/Arrow";
import SelectionList from "./SelectionList";
import RangeInput from "./RangeInput";
import TimePicker from "./TimePicker";
// import PidComponent from './PID/PidComponent'
// import PIDInput from "./PID/PIDInput_1";
import ModelInput from "./ModelInput";
import { checkPropTypes } from "prop-types";

const GrafanaPopup = (props) => (
  <Popup
    trigger={(open) => (
      <div
        className="main-text-div"
        style={{ textAlign: "center", color: "#FFFFFF", opacity: 0.9 }}
      >
        <span style={{ margin: "auto", display: "table" }}>{props.result}</span>
      </div>
    )}
    position={props.position}
    contentStyle={{
      width: "auto",
      backgroundColor: "#000000",
      border: "1px solid rgba(29,27,27,0.75)",
      borderRadius: "5px",
      boxShadow: "1px 1px 5px 0 rgba(51, 50, 50, .75)",
    }}
    arrowStyle={{
      background: "#C75E24",
    }}
  >
    <div className="content-div">
      <iframe
        src={
          "https://iot.research.hamk.fi/visu/d-solo/Kogkmv2Wz/venect-measurements?orgId=4&from=now-6h&to=now&panelId=" +
          props.remotePointList.panelId
        }
        title={props.remotePointList.measurement}
        width="450"
        height="200"
        frameborder="0"
      />
    </div>
  </Popup>
);

const Container = (props) => {
  const { position, measurement, button, arrowPosition } = props.remotePointList;
  // const {top, left} = arrowPosition;
  // let arrowStyle = {
  //   position: "absolute",
  //   top: arrowPosition !== undefined ? arrowPosition.top + "%" : "",
  //   left: arrowPosition !== undefined ? arrowPosition.left + "%" : "",
  //   // display: "flex",
  //   //       flexDirection: "row",
  //   //       justifyContent: "space-evenly"
  // };

  let imageStyle =
    measurement == "Fan"
      ? {
          position: "absolute",
          top: `${position.top}%`,
          left: `${position.left}%`,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
        }
      : "";
  let containerStyle =
    measurement.includes("AK_P") ||
    measurement.includes("P1") ||
    measurement.includes("P2")
      ? {
          position: "absolute",
          top: `${position.top}%`,
          left: `${position.left}%`,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
        }
      : {
          position: "absolute",
          top: `${position.top}%`,
          left: `${position.left}%`,
        };
  var result = DataMapping({
    id: props.remotePointList.measurement,
    message: props.message,
  });

  let measurementColor = "#FFFFE0";
  switch (props.remotePointList.measurement) {
    case "HV-001":
    case "HV-004":
    case "HV-007":
    case "HV-003":
    case "HV-002":
    case "HV-005":
    case "HV-006":
    case "HV-008":
    case "HV-013":
    case "HV-009":
    case "HV-010":
    case "HV-012":
    case "HV-011":
    case "Fan":
    case "Burning":
      if (result == "OFF") measurementColor = "#FF6347";
      break;
  }
  // console.log(props.remotePointList)

  // if (props.remotePointList.measurement == "HV-001") {
  //   console.log(result)
  // }

  // console.log(result)
  // console.log(props)
  // choose whether chips are under or beside measurements ID
  return (
    <div>
      {/* {measurement == "Fan" && props.message.Fan == true ? (
        <img style={imageStyle} src={FanImage} height="88" />
      ) : (
        ""
      )} */}
      {/* {console.log(props)} */}
      <div style={containerStyle}>
        {/* {button == "yes" ? (
          <div style={arrowStyle}>
            <ArrowMoving
              remotePointList={props.remotePointList}
              message={
                result == "ON"
                  ? true
                  : result || result == "OFF"
                  ? false
                  : result
              }
            />{" "}
          </div>
        ) : (
          ""
        )} */}
        {/* {measurement == "Burning"  ? <img class="circular--square" src={FireImage} width="77" height="77"/> : ""} */}

        {/* {measurement == "Burning" && props.message.Burning == false ? (
          <img class="circular--square" src={NoFire} width="77" height="77" />
        ) : (
          ""
        )}

        {(measurement == "Burning" && props.message.Burning == true) && (
          <img class="circular--square" src={FireImage} width="77" height="77"/>
        )} */}
        <div style={{ textAlign: "center", color: measurementColor }}>
          {measurement}
        </div>
        {result !== "ON" &&
          result !== "OFF" &&
          measurement !== "Fan" &&
          measurement !== "SolarLoopCharge" &&
          measurement !== "WaterTankCharge" &&
          measurement !== "BoilerBurner" &&
          measurement !== "Burning" &&
          measurement !== "OverrideTankProsess" &&
          measurement !== "OverrideFeederSpeedControl" &&
          measurement !== "OverrideSolarProsess" &&
          measurement !== "OverrideBurningProsess" &&
          measurement !== "OverridePrimaryFanSpeed" &&
          measurement !== "TestingMode" &&
          measurement !== "FeederControlFrequency" &&
          measurement !== "PrimaryFanSpeed" &&
          measurement !== "BurningTemp" &&
          measurement !== "WaterTemp" &&
          measurement !== "FeederControlTimeOff" &&
          measurement !== "FeederControlTimeOn" && (
            <GrafanaPopup {...props} result={result} />
          )}
        {button == "yes" &&
          (measurement.includes("HV-001") ||
            measurement.includes("HV-002") ||
            measurement.includes("HV-003") ||
            measurement.includes("HV-004") ||
            measurement.includes("HV-005") ||
            measurement.includes("HV-006") ||
            measurement.includes("HV-007") ||
            measurement.includes("HV-008") ||
            measurement.includes("HV-009") ||
            measurement.includes("HV-010") ||
            measurement.includes("HV-011") ||
            measurement.includes("HV-012") ||
            measurement.includes("HV-013")) && (
            <div>
              <SwitchOnOff
                topic={props.remotePointList.measurement}
                message={
                  result == "ON"
                    ? true
                    : result || result == "OFF"
                    ? false
                    : result
                }
              />
            </div>
          )}
        {(measurement == "SolarLoopCharge" ||
          measurement == "WaterTankCharge" ||
          measurement == "BoilerBurner") && (
          <div>
            <SelectionList
              topic={props.remotePointList.measurement}
              message={
                (measurement == "SolarLoopCharge" &&
                  props.message.SolarLoopCharge) ||
                (measurement == "WaterTankCharge" &&
                  props.message.WaterTankCharge) ||
                (measurement == "BoilerBurner" && props.message.BoilerBurner)
              }
            />
          </div>
        )}
        {((button == "yes" && measurement == "Burning") ||
          measurement == "Fan" ||
          measurement == "OverrideBurningProsess" ||
          measurement == "OverrideSolarProsess" ||
          measurement == "OverrideFeederSpeedControl" ||
          measurement == "OverridePrimaryFanSpeed" ||
          measurement == "TestingMode" ||
          measurement == "OverrideTankProsess") && (
          <div>
            <SwitchOnOff_boolean
              topic={props.remotePointList.measurement}
              message={
                // props.remotePointList.measurement == "Burning"
                //   ? props.message.Burning
                //   : props.message.Fan
                measurement == "Burning"
                  ? props.message.Burning
                  : measurement == "Fan"
                  ? props.message.Fan
                  : measurement == "OverrideBurningProsess"
                  ? props.message.OverrideBurningProsess
                  : measurement == "OverrideTankProsess"
                  ? props.message.OverrideTankProsess
                  : measurement == "OverrideFeederSpeedControl"
                  ? props.message.OverrideFeederSpeedControl
                  : measurement == "OverridePrimaryFanSpeed"
                  ? props.message.OverridePrimaryFanSpeed
                  : measurement == "TestingMode"
                  ? props.message.TestingMode
                  : props.message.OverrideSolarProsess
              }
            />
          </div>
        )}
        {console.log(props.message.feederControlFrequency)}
        {measurement == "FeederControlFrequency" && (
          <RangeInput
            topic={props.remotePointList.measurement}
            maxValue={
              props.message.feederControlFrequency &&
              props.message.feederControlFrequency / 0.25
            }
            minValue={0}
            unit={"ms"}
          />
        )}
        {measurement == "PrimaryFanSpeed" && (
          <RangeInput
            topic={props.remotePointList.measurement}
            maxValue={
              props.message.PrimaryFanSpeed && props.message.PrimaryFanSpeed
            }
            minValue={0}
            unit={"ms"}
          />
        )}
        {measurement == "BurningTemp" && (
          <RangeInput
            topic={props.remotePointList.measurement}
            maxValue={
              props.message.BurningTemp && props.message.BurningTemp / 3
            }
            minValue={0}
            unit={"ms"}
          />
        )}
        {measurement == "WaterTemp" && (
          <RangeInput
            topic={props.remotePointList.measurement}
            maxValue={props.message.WaterTemp && props.message.WaterTemp}
            minValue={0}
            unit={"ms"}
          />
        )}
        {(measurement == "FeederControlTimeOn" ||
          measurement == "FeederControlTimeOff") && (
          <TimePicker
            currentTime={
              measurement == "FeederControlTimeOn"
                ? props.message.feederControlTimeOn
                : props.message.feederControlTimeOff
            }
            topic={props.remotePointList.measurement}
            timeOn={measurement == "FeederControlTimeOn" ? true : false}
          />
        )}
        {measurement.includes("HV") && result !== "OFF" && (
          <Arrow waterFlow={props.remotePointList.waterFlow} />
        )}
        {/* {(measurement.includes("HV-001") ||
        measurement.includes("HV-002") ||
        measurement.includes("HV-003") ||
        measurement.includes("HV-004") ||
        measurement.includes("HV-005") ||
        measurement.includes("HV-006") ||
        measurement.includes("HV-007") ||
        measurement.includes("HV-008") ||
        measurement.includes("HV-009")) && <br />} */}
        {/* {measurement == 'PidControl' && (<PidComponent 
        currentValue_1 = {props.message['TE-009']}
        currentValue_2 = {props.message['TE-011']}
        currentValue_3 = {props.message['TE-013']}
        setPoint
        />)} */}
        {/* {console.log(props.message)} */}
        {/* {measurement == 'FeederSpeedControl' && console.log(props.message)} */}
        {measurement == "FeederSpeedControl" && (
          <div>
            <ModelInput
              topic={props.remotePointList.measurement}
              message={props.message["FeederSpeedControl"]}
              currentValue_1={props.message["TE-009"]}
              currentValue_2={props.message["TE-011"]}
              currentValue_3={props.message["TE-013"]}
              setPoint_1={props.message["TE-017"]}
              setPoint_2={props.message["TE-021"]}
              takeSetPoint_1={props.message["HV-001"]}
              takeSetPoint_2={props.message["HV-004"]}
              takeSetPoint_3={props.message["HV-007"]}
              // takeCurrentValue_1={props.message["HV-017"]}
              // takeCurrentValue_2={props.message["HV-021"]}
            />
          </div>
          // <div>
          //   <PIDInput
          //     currentValue_1={props.message["TE-009"]}
          //     // currentValue_2={props.message["TE-011"]}
          //     // currentValue_3={props.message["TE-013"]}
          //     setPoint_1={props.message["TE-017"]}
          //     // setPoint_2={props.message["TE-021"]}
          //     // takeSetPoint_1={props.message["HV-001"]}
          //     // takeSetPoint_2={props.message["HV-004"]}
          //     // takeSetPoint_3={props.message["HV-007"]}
          //     // takeCurrentValue_1={props.message["HV-017"]}
          //     // takeCurrentValue_2={props.message["HV-021"]}
          //   />
          // </div>
        )}
      </div>
    </div>
  );
};

// map all points (from remotePointList) with html's style in Container, to display on loop
export default function Points(props) {
  // console.log(props)
  const points = remotePointList.map((e) => (
    <Container key={e.measurement} remotePointList={e} message={props.messages} />
  ));
  return points;
}
